import styled from 'styled-components';
import { theme } from './theme';

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'minimal' }>`
  color: ${props => props.variant === 'minimal' ? theme.colors.primary.main : theme.colors.text.white};
  font-weight: bold;
  padding: 12px 20px;
  border: ${props => props.variant === 'minimal' ? `2px solid ${theme.colors.primary.main}` : 'none'};
  border-radius: ${theme.borderRadius.md};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  box-shadow: ${theme.shadows.button};
  text-decoration: none;
  font-size: ${theme.typography.body.fontSize};
  background: ${props => {
    switch (props.variant) {
      case 'primary':
        return theme.colors.primary.gradient;
      case 'secondary':
        return theme.colors.secondary.gradient;
      case 'success':
        return theme.colors.success.gradient;
      case 'danger':
        return theme.colors.danger.gradient;
      case 'minimal':
        return 'transparent';
      default:
        return theme.colors.primary.gradient;
    }
  }};

  &:disabled {
    background: #E0E0E0;
    color: #A0A0A0;
    cursor: not-allowed;
    box-shadow: none;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.md};
`;

export const Card = styled.div`
  background: ${theme.colors.background.paper};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.header`
  background: ${theme.colors.primary.gradient};
  color: ${theme.colors.text.white};
  padding: ${theme.spacing.md};
  text-align: left;
  font-size: ${theme.typography.h1.fontSize};
  font-weight: ${theme.typography.h1.fontWeight};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding-left: 40px;
`;

export const SubHeader = styled.div`
  text-align: center;
  font-size: ${theme.typography.body.fontSize};
  color: ${theme.colors.text.secondary};
  margin-top: ${theme.spacing.sm};
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.body.fontSize};
  margin-bottom: ${theme.spacing.md};

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary.main};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  max-width: 400px;
  margin: 0 auto;
`;

export const Badge = styled.span<{ variant: 'pending' | 'active' | 'complete' }>`
  display: inline-block;
  padding: 5px 12px;
  border-radius: ${theme.borderRadius.lg};
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 5px;
  background-color: ${props => {
    switch (props.variant) {
      case 'pending':
        return '#FFC107';
      case 'active':
        return '#28A745';
      case 'complete':
        return '#17A2B8';
      default:
        return '#FFC107';
    }
  }};
  color: ${props => props.variant === 'pending' ? '#664d03' : theme.colors.text.white};
`;